import uPlot from 'uplot';
import { Quadtree, pointWithin } from './quadtree';
import { distribute, SPACE_BETWEEN } from './distribute';
var pxRatio = devicePixelRatio;
var groupDistr = SPACE_BETWEEN;
var barDistr = SPACE_BETWEEN;
var font = Math.round(10 * pxRatio) + 'px Arial';
function walkTwo(groupWidth, barWidth, yIdx, xCount, yCount, xDim, xDraw, yDraw) {
    distribute(xCount, groupWidth, groupDistr, null, function (ix, offPct, dimPct) {
        var groupOffPx = xDim * offPct;
        var groupWidPx = xDim * dimPct;
        xDraw && xDraw(ix, groupOffPx, groupWidPx);
        yDraw &&
            distribute(yCount, barWidth, barDistr, yIdx, function (iy, offPct, dimPct) {
                var barOffPx = groupWidPx * offPct;
                var barWidPx = groupWidPx * dimPct;
                yDraw(ix, groupOffPx + barOffPx, barWidPx);
            });
    });
}
/**
 * @internal
 */
export function getConfig(opts) {
    var ori = opts.xOri, dir = opts.xDir, groupWidth = opts.groupWidth, barWidth = opts.barWidth, formatValue = opts.formatValue, onHover = opts.onHover, onLeave = opts.onLeave;
    var qt;
    var drawBars = function (u, sidx, i0, i1) {
        return uPlot.orient(u, sidx, function (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim, moveTo, lineTo, rect) {
            var fill = new Path2D();
            var stroke = new Path2D();
            var numGroups = dataX.length;
            var barsPerGroup = u.series.length - 1;
            var y0Pos = valToPosY(0, scaleY, yDim, yOff);
            var _dir = dir * (ori === 0 ? 1 : -1);
            walkTwo(groupWidth, barWidth, sidx - 1, numGroups, barsPerGroup, xDim, null, function (ix, x0, wid) {
                var lft = Math.round(xOff + (_dir === 1 ? x0 : xDim - x0 - wid));
                var barWid = Math.round(wid);
                if (dataY[ix] != null) {
                    var yPos = valToPosY(dataY[ix], scaleY, yDim, yOff);
                    var btm = Math.round(Math.max(yPos, y0Pos));
                    var top_1 = Math.round(Math.min(yPos, y0Pos));
                    var barHgt = btm - top_1;
                    var strokeWidth = series.width || 0;
                    if (strokeWidth) {
                        rect(stroke, lft + strokeWidth / 2, top_1 + strokeWidth / 2, barWid - strokeWidth, barHgt - strokeWidth);
                    }
                    rect(fill, lft, top_1, barWid, barHgt);
                    var x = ori === 0 ? Math.round(lft - xOff) : Math.round(top_1 - yOff);
                    var y = ori === 0 ? Math.round(top_1 - yOff) : Math.round(lft - xOff);
                    var w = ori === 0 ? barWid : barHgt;
                    var h = ori === 0 ? barHgt : barWid;
                    qt.add({ x: x, y: y, w: w, h: h, sidx: sidx, didx: ix });
                }
            });
            return {
                stroke: stroke,
                fill: fill,
            };
        });
    };
    var drawPoints = formatValue == null
        ? false
        : function (u, sidx, i0, i1) {
            u.ctx.font = font;
            u.ctx.fillStyle = 'white';
            uPlot.orient(u, sidx, function (series, dataX, dataY, scaleX, scaleY, valToPosX, valToPosY, xOff, yOff, xDim, yDim, moveTo, lineTo, rect) {
                var numGroups = dataX.length;
                var barsPerGroup = u.series.length - 1;
                var _dir = dir * (ori === 0 ? 1 : -1);
                walkTwo(groupWidth, barWidth, sidx - 1, numGroups, barsPerGroup, xDim, null, function (ix, x0, wid) {
                    var lft = Math.round(xOff + (_dir === 1 ? x0 : xDim - x0 - wid));
                    var barWid = Math.round(wid);
                    // prettier-ignore
                    if (dataY[ix] != null) {
                        var yPos = valToPosY(dataY[ix], scaleY, yDim, yOff);
                        /* eslint-disable no-multi-spaces */
                        var x = ori === 0 ? Math.round(lft + barWid / 2) : Math.round(yPos);
                        var y = ori === 0 ? Math.round(yPos) : Math.round(lft + barWid / 2);
                        u.ctx.textAlign = ori === 0 ? 'center' : dataY[ix] >= 0 ? 'left' : 'right';
                        u.ctx.textBaseline = ori === 1 ? 'middle' : dataY[ix] >= 0 ? 'bottom' : 'top';
                        /* eslint-enable */
                        u.ctx.fillText(formatValue(sidx, dataY[ix]), x, y);
                    }
                });
            });
            return false;
        };
    /*
      const yRange: Scale.Range = (u, dataMin, dataMax) => {
        // @ts-ignore
        let [min, max] = uPlot.rangeNum(0, dataMax, 0.05, true);
        return [0, max];
      };
    */
    var xSplits = function (u, axisIdx) {
        var dim = ori === 0 ? u.bbox.width : u.bbox.height;
        var _dir = dir * (ori === 0 ? 1 : -1);
        var splits = [];
        distribute(u.data[0].length, groupWidth, groupDistr, null, function (di, lftPct, widPct) {
            var groupLftPx = (dim * lftPct) / pxRatio;
            var groupWidPx = (dim * widPct) / pxRatio;
            var groupCenterPx = groupLftPx + groupWidPx / 2;
            splits.push(u.posToVal(groupCenterPx, 'x'));
        });
        return _dir === 1 ? splits : splits.reverse();
    };
    // @ts-ignore
    var xValues = function (u) { return u.data[0]; };
    var hovered = null;
    var barMark = document.createElement('div');
    barMark.classList.add('bar-mark');
    barMark.style.position = 'absolute';
    barMark.style.background = 'rgba(255,255,255,0.4)';
    // hide crosshair cursor & hover points
    var cursor = {
        x: false,
        y: false,
        points: {
            show: false,
        },
    };
    // disable selection
    // uPlot types do not export the Select interface prior to 1.6.4
    var select = {
        show: false,
    };
    var init = function (u) {
        var over = u.root.querySelector('.u-over');
        over.style.overflow = 'hidden';
        over.appendChild(barMark);
    };
    var drawClear = function (u) {
        qt = qt || new Quadtree(0, 0, u.bbox.width, u.bbox.height);
        qt.clear();
        // clear the path cache to force drawBars() to rebuild new quadtree
        u.series.forEach(function (s) {
            // @ts-ignore
            s._paths = null;
        });
    };
    // handle hover interaction with quadtree probing
    var setCursor = function (u) {
        var found = null;
        var cx = u.cursor.left * pxRatio;
        var cy = u.cursor.top * pxRatio;
        qt.get(cx, cy, 1, 1, function (o) {
            if (pointWithin(cx, cy, o.x, o.y, o.x + o.w, o.y + o.h)) {
                found = o;
            }
        });
        if (found) {
            // prettier-ignore
            if (found !== hovered) {
                /* eslint-disable no-multi-spaces */
                barMark.style.display = '';
                barMark.style.left = found.x / pxRatio + 'px';
                barMark.style.top = found.y / pxRatio + 'px';
                barMark.style.width = found.w / pxRatio + 'px';
                barMark.style.height = found.h / pxRatio + 'px';
                hovered = found;
                /* eslint-enable */
                if (onHover != null) {
                    onHover(hovered.sidx, hovered.didx);
                }
            }
        }
        else if (hovered != null) {
            if (onLeave != null) {
                onLeave(hovered.sidx, hovered.didx);
            }
            hovered = null;
            barMark.style.display = 'none';
        }
    };
    return {
        // cursor & select opts
        cursor: cursor,
        select: select,
        // scale & axis opts
        // yRange,
        xValues: xValues,
        xSplits: xSplits,
        // pathbuilders
        drawBars: drawBars,
        drawPoints: drawPoints,
        // hooks
        init: init,
        drawClear: drawClear,
        setCursor: setCursor,
    };
}
//# sourceMappingURL=bars.js.map